<template>
  <div class="">
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="title"
        :transShow="false"
        :transOpen="false"
        :iconShow="!isNewTab"
        @icon-click="back"
      />
    </div>
    <div class="reparation-content">
      <div class="page-title" v-if="!isH5">{{ reparationRules.title }}</div>
      <div class="reparation-rules">
        <div class="reparation-rules-desc" v-if="isNormal">
          <span
            v-for="item in reparationRules.desc"
            :class="{ higLight: item.highLight }"
            :key="item"
            >{{ item.txt }}</span
          >
        </div>
        <div class="reparation-rules-short" v-if="isNormal">
          <div
            class="reparation-rules-short-item"
            v-for="item in reparationRules.short"
            :key="item"
          >
            <p class="reparation-rules-short-title">{{ item.time }}</p>
            <p class="reparation-rules-short-desc">{{ item.coupon }}</p>
          </div>
        </div>
        <div class="reparation-rules-detail">
          <div class="reparation-rules-detail-title" v-if="isNormal">
            <span class="left-line"></span>
            <span class="rules-title-text">{{
              reparationRules.rules.title
            }}</span>
            <span class="right-line"></span>
          </div>
          <div class="reparation-rules-detail-content">
            <div
              class="reparation-rules-detail-item"
              v-for="(item, index) in reparationRules.rules.detailConst"
              :key="item + index"
            >
              <p v-if="!!(item instanceof Array)">
                <span
                  v-for="itemPart in item"
                  :class="{ higLight: itemPart.highLight }"
                  :key="itemPart"
                  >{{ itemPart.txt }}</span
                >
              </p>
              <p v-else>{{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reparationRules from '@/const/reparation-rules';
import PageMbHeader from '@/components/PageMbHeader';
import { mapState } from 'vuex';
import { sprintf } from 'sprintf-js';
import { getIsNewTab } from '@/utils/tools';

export default {
  data() {
    return {
      reparationLevel: [],
      ignoreTimeRange: {},
      title: this.$t('超时赔付规则说明'),
    };
  },
  components: {
    PageMbHeader,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    isNormal() {
      return !!(this.reparationLevel && this.reparationLevel.length);
    },
    reparationRules() {
      if (this.isNormal) {
        return reparationRules.normal;
      } else {
        return reparationRules.abnormal;
      }
    },
    isNewTab() {
      return getIsNewTab();
    },
  },
  methods: {
    getReparationConfig() {
      let reparationConfigSrc = this.$route.query.config;
      reparationConfigSrc =
        reparationConfigSrc && decodeURIComponent(reparationConfigSrc);
      reparationConfigSrc =
        reparationConfigSrc && JSON.parse(reparationConfigSrc);
      if (
        reparationConfigSrc &&
        reparationConfigSrc.benchmark instanceof Array
      ) {
        this.reparationLevel = reparationConfigSrc.benchmark.map((item) => {
          return {
            ...item,
            time: item && +item.waitTime,
            coupon: item && +item.amount,
          };
        });
      }
      this.ignoreTimeRange =
        reparationConfigSrc && reparationConfigSrc.ignoreHours;
    },
    spliceRules() {
      let me = this;
      if (me.isNormal) {
        // 赔付时间段部分
        if (this.ignoreTimeRange) {
          let morningIgnoreTimeRange = '';
          let nightIgnoreTimeRange = '';
          morningIgnoreTimeRange = sprintf(
            this.$t('早间：%s-%s'),
            this.ignoreTimeRange.m[0],
            this.ignoreTimeRange.m[1]
          );
          nightIgnoreTimeRange = sprintf(
            this.$t('晚间：%s-%s'),
            this.ignoreTimeRange.n[0],
            this.ignoreTimeRange.n[1]
          );
          me.reparationRules.rules.detailConst.splice(
            4,
            0,
            morningIgnoreTimeRange,
            nightIgnoreTimeRange
          );
        }
        // 详细文案中关于赔付券部分
        let detailRules = [];
        me.reparationRules.short = [];
        me.reparationLevel.forEach((item, index) => {
          let ruleItem = {};
          let detailRuleCouponTxt = '';
          ruleItem.time = sprintf(
            this.$t('延迟送达%s分钟以上', item.time),
            item.time
          );
          switch (item.couponSort) {
            case 'FreeDelivery':
              ruleItem.coupon = sprintf(
                this.$t('将赔付给您%s张免配送费券'),
                item.coupon
              );
              detailRuleCouponTxt = sprintf(
                this.$t('送您%s张免配送费券；'),
                item.coupon
              );
              break;
            case 'Discount':
              ruleItem.coupon = sprintf(
                this.$t('将赔付给您1张%s折扣券'),
                item.discountRate
              );
              detailRuleCouponTxt = sprintf(
                this.$t('送您1张%s折扣券；'),
                item.discountRate
              );
              break;
            case 'CashCoupons':
              ruleItem.coupon = sprintf(
                this.$t('将赔付给您1张%s优惠券'),
                item.cashShow
              );
              detailRuleCouponTxt = sprintf(
                this.$t('送您1张%s优惠券；'),
                item.cashShow
              );
              break;
          }
          me.reparationRules.short.push(ruleItem);
          if (me.reparationLevel[index + 1]) {
            detailRules.push(
              `(${index + 1}) ` +
                sprintf(
                  this.$t(
                    '订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，'
                  ),
                  item.time,
                  me.reparationLevel[index + 1].time
                ) +
                detailRuleCouponTxt
            );
          } else {
            detailRules.push(
              `(${index + 1}) ` +
                sprintf(
                  this.$t('订单实际送达时间晚于预计送达时间%s分钟以上，'),
                  item.time
                ) +
                detailRuleCouponTxt
            );
          }
        });
        me.reparationRules.rules.detailConst.splice(1, 0, ...detailRules);
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    this.getReparationConfig();
    this.spliceRules();
  },
};
</script>
<style lang="scss" scoped>
@import '../control_global.scss';
.reparation-content {
  height: calc(100vh - 180px);
  overflow-y: auto;
  position: relative;
  margin: 60px auto;
  max-width: 470px;
  background: #fff;
  padding: 32px 24px;
  color: #333;
  border-radius: 8px;
  .page-title {
    font-family: 'Aspira Medium';
    font-size: 24px;
    line-height: 28px;
    color: #000000;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .reparation-rules {
    font-family: 'Aspira Regular';
    .reparation-rules-desc {
      font-family: 'Aspira Light';
      font-size: 14px;
      line-height: 18px;
      color: #666;
      font-weight: 200;
      .higLight {
        @include font-color();
      }
    }
  }
  .reparation-rules-detail-content {
    color: #666666;
    .higLight {
      @include font-color();
    }
  }
  .reparation-rules-short {
    background: #f5f5f7;
    box-sizing: border-box;
    border-radius: 8px;
    margin: 32px 0;
  }
  .reparation-rules-short-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px #e1e1e1 solid;
    border-radius: solid 1px;
    font-family: 'Aspira Medium';
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    font-weight: 500;
    margin: 0 20px;
    padding: 20px 0;
    p:first-child {
      font-family: 'Aspira Medium';
      font-size: 16px;
      line-height: 20px;
      color: #000000;
      text-align: justify;
      font-weight: 500;
      margin-bottom: 6px;
    }
    p {
      font-family: 'Aspira Light';
      font-size: 14px;
      line-height: 18px;
      color: #000000;
      text-align: justify;
      font-weight: 200;
    }
  }
  .reparation-rules-short-item:last-child {
    border-bottom: none;
  }
  .reparation-rules-detail .reparation-rules-detail-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Aspira Regular';
    font-size: 14px;
    line-height: 18px;
    color: #666666;
    text-align: center;
    margin-bottom: 20px;
  }
  .rules-title-text {
    font-family: 'Aspira Medium';
    font-size: 14px;
    line-height: 18px;
    color: #666666;
    text-align: justify;
  }
  .left-line {
    display: inline-block;
    flex-grow: 1;
    height: 1px;
    margin-right: 20px;
    background-image: linear-gradient(-90deg, #b8b8b8 0%, #ffffff 100%);
  }
  .right-line {
    display: inline-block;
    flex-grow: 1;
    height: 1px;
    margin-left: 20px;
    background-image: linear-gradient(-90deg, #ffffff 0%, #b8b8b8 100%);
  }
  .reparation-rules-detail-item {
    margin-bottom: 20px;
    font-family: 'Aspira Light';
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
// 移动端适配
@media screen and (max-width: 768px) {
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .cate-header-wrapper {
    position: relative;
  }
  .reparation-content {
    height: auto;
    min-height: calc(100vh - #{rem(24)});
    position: relative;
    overflow-y: auto;
    margin: 0 auto;
    max-width: auto;
    background: #fff;
    padding: rem(24);
    color: #333;
    .page-title {
      font-family: 'Aspira Medium';
      font-size: rem(48);
      line-height: rem(56);
      color: #000000;
      margin-bottom: rem(40);
    }
    .reparation-rules {
      font-family: 'Aspira Regular';
      .reparation-rules-desc {
        font-family: 'Aspira Thin';
        font-size: rem(28);
        line-height: rem(34);
        color: #666;
      }
    }
    .reparation-rules-short {
      background: #f5f5f7;
      padding: 0 rem(40);
      box-sizing: border-box;
      border-radius: rem(20);
      margin: rem(40) rem(20);
    }
    .reparation-rules-short-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-bottom: rem(2) #e1e1e1 solid;
      border-radius: solid rem(2);
      font-family: 'Aspira Medium';
      font-size: rem(32);
      line-height: rem(38);
      color: #000000;
      margin: 0 rem(40);
      padding: rem(40) 0;
      p:first-child {
        margin-bottom: rem(12);
        font-family: 'Aspira Medium';
        font-size: rem(32);
        line-height: rem(38);
        color: #000000;
        text-align: justify;
        margin-bottom: rem(12);
      }
      p {
        font-family: 'Aspira Light';
        font-size: rem(28);
        line-height: rem(34);
        color: #000000;
        text-align: justify;
      }
    }
    .reparation-rules-short-item:last-child {
      border-bottom: none;
    }
    .reparation-rules-detail .reparation-rules-detail-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Aspira Regular';
      font-size: rem(28);
      line-height: rem(34);
      color: #666666;
      text-align: center;
      margin-bottom: rem(40);
    }
    .rules-title-text {
      font-family: 'Aspira Light';
      font-size: rem(28);
      line-height: rem(34);
      color: #666666;
      text-align: justify;
    }
    .left-line {
      display: inline-block;
      flex-grow: 1;
      height: rem(4);
      margin-right: rem(20);
      background-image: linear-gradient(-90deg, #b8b8b8 0%, #ffffff 100%);
    }
    .right-line {
      display: inline-block;
      flex-grow: 1;
      height: rem(4);
      margin-left: rem(20);
      background-image: linear-gradient(-90deg, #ffffff 0%, #b8b8b8 100%);
    }
    .reparation-rules-detail-item {
      margin-bottom: rem(40);
      p {
        font-size: rem(28);
        line-height: rem(34);
      }
    }
  }
}
</style>